import { formatDate } from '../../../utils/formatDate';

export const formatDollar = (amount: number): string =>
  `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatDepartmentGroups = (groups: string[]): string => (groups.length > 0 ? groups.join(', ') : '—');

export const formatOptionalDate = (isoLike: string | null): string => {
  if (!isoLike) return '—';
  return formatDate(isoLike) || '—';
};

export const permanentOffTooltip = (name: string | null, at: string | null, reason: string | null): string => {
  const who = name || 'An admin';
  const when = at ? new Date(at).toLocaleString() : 'an unknown date';
  return `${who} turned collections off on ${when} — reason: ${reason || 'not provided'}`;
};

export const ADMIN_ONLY_TOGGLE_TOOLTIP = 'Only an admin can turn collection emails on/off.';
export const ADMIN_ONLY_PERMANENT_TOOLTIP = 'Only an admin can permanently disable collection emails.';
